export default __webpack_public_path__ + "static/media/haesli-i-dae-gruebe.ffc4c712.webp";